// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__16rgp","inputWrap":"CustomTip_inputWrap__1-9f9"};